import { A } from '../actions/finances';
import update from 'immutability-helper';

const initialState = {
  getBillingDocs: {
    isFetching: false,
    error: null,
  },
  data: [],
  totalItems: 0,
};

const finances = (state = initialState, action) => {
  switch (action.type) {
    case A.REQUEST_GET_BILLING_DOCS:
      return update(state, {
        getBillingDocs: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_BILLING_DOCS:
      return update(state, {
        getBillingDocs: {
          isFetching: { $set: false },
        },
        data: { $set: action.data.documents },
        totalItems: { $set: action.data.recordsTotal },
      });

    case A.ERROR_GET_BILLING_DOCS:
      return update(state, {
        getBillingDocs: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default finances;
